var map = {
	"./music-instructions.json": 3285,
	"./music-library-intro2024.json": 3286,
	"./music-library-launch2024.json": 3287,
	"./music-progression.json": 3288,
	"./startSourcesAdvanced.json": 3289,
	"./startSourcesSimple.json": 3290,
	"./startSourcesSimple2.json": 3291,
	"./startSourcesTracks.json": 3292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2710;